import TicketsApi from '@app/api/public/TicketsApi';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { L } from '../../../lib/i18n';
import { TicketSettingsQueryKey } from './TicketSettingsQueries';

const useSaveTicketResponse = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (ticketInfo: string) => {
            console.log(ticketInfo);
            return TicketsApi.saveServiceResponse(ticketInfo);
        },

        onSuccess: () => {
            toast.success(L('ticket_information_saved'));
            queryClient.invalidateQueries(TicketSettingsQueryKey.all);
        },
    });
};

export default useSaveTicketResponse;
